/**
 * Word normalization for word-family cache key.
 * Lowercase, trim, collapse whitespace. Language-aware adjustments are kept minimal —
 * Gemini handles morphology, we just deduplicate cosmetic variants.
 */
export function normalizeWord(word: string, _language: string): string {
  return word
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}
